import { expect } from 'chai';

// CJS-only
if (typeof process !== 'undefined') {
  describe('Aggregate index test', () => {
    it('index.js', async () => {
        // @ts-ignore
        const index = await import('./index');
        // Expect title-case named exports
        const keys = Object.keys(index);
        expect(keys.length).at.least(1);
        keys.forEach(key => {
          expect(key).match(/^[A-Z][a-z].+/)
          expect(key).not.match(/^UNSAFE_/)
        });
    });

    it('types/index.d.ts', async () => {
      const { default: fs } = await import('fs');
      const contents = fs.readFileSync('./dist/types/index.d.ts').toString();
      expect(contents.length).greaterThan(0);
    });

  })
}
